<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/resources',
          title: 'Resources'
        },
        {
          href: canonicalPaths.relative,
          title: 'Download'
        }
      ]"
      :value="heroSection"
    >
    </HeroSection>

    <DownloadSection
      :contact-form-config="contactFormConfig"
      :download="download"
      :value="downloadPage.download_section"
      class="mb-16 px-md-16 hero-section hero-below-offset"
    />

    <DividerSection class="mb-16" />

    <ContactCtaSection
      :value="downloadPage.contact_cta_section"
      class="mb-16"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { usePageContext } from '#root/renderer/usePageContext'

const props = defineProps({
  contactFormConfig: {
    default: undefined,
    type: Object
  },
  download: {
    required: true,
    type: Object
  },
  downloadPage: {
    required: true,
    type: Object
  }
})

const { canonicalPaths } = usePageContext()
const heroSection = computed(() => {
  const section = Object.assign({}, props.downloadPage.hero_section)
  section.title = props.download.title
  return section
})
</script>
